export default __webpack_public_path__ + "static/media/9.73e95f97.jpg";